<template>
	<div>
	<el-collapse >
		<el-collapse-item title="基础设置" name="1">
			<el-form :model="shu.jichupeizhi">
				<el-form-item label="开启分销" style="margin-left: 120px;margin-top: 20px">
					<el-select v-model="shu.jichupeizhi.cengji" placeholder="请选择" style="width: 90%">
						<el-option :label="i-1+'级'" :value="i-1" v-for="i in 6"></el-option>
					</el-select>
				</el-form-item>	
				<el-form-item label="会员特权" style="margin-left: 120px;margin-top: 20px">
					<Bianjiqi v-model="shu.jichupeizhi.huiyuantequan"></Bianjiqi>
				</el-form-item>		
				<el-form-item label="当前版本号" label-width="200px">
					<el-input v-model="shu.jichupeizhi.banbenhao" placeholder="当前版本号"></el-input>
				</el-form-item>
				<el-form-item style="margin-left: 120px;">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item>
		
		<el-collapse-item title="提现设置" name="2">
			<el-form ref="form" :model="shu.tixian" label-width="100px" style="margin-top: 20px;padding: 0 120px;">
				<el-form-item label="提现手续费">
					<el-input v-model="shu.tixian.shouxufei"></el-input>
				</el-form-item>
				<el-form-item label="满多少提现">
					<el-input v-model="shu.tixian.qiti" placeholder="提现的起提额度，满多少元以上才可提现"></el-input>
				</el-form-item>
				<el-form-item label="开启自动提现">
					<el-radio-group v-model="shu.tixian.zidongtixian" style="margin-left: 20px;">
						<el-radio label="0">关闭</el-radio>
						<el-radio label="1">开启</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item>
		
		<div><span class="biaoti">短信接口</span></div>		
		<el-collapse-item title="阿里大鱼( 申请)" name="7">
			<el-form label-width="80px" :model="shu.duanxin" style="margin-top: 20px;">
				<el-form-item label="App key" label-width="200px">
					<el-input v-model="shu.duanxin.dayu.key" placeholder="请输入AppId"></el-input>
				</el-form-item>
				<el-form-item label="App Secret" label-width="200px">
					<el-input v-model="shu.duanxin.dayu.secret" placeholder="请输入AppId"></el-input>
				</el-form-item>
				<el-form-item label="发送模板" label-width="200px" v-if="shu.duanxin">
					<el-input  placeholder="登录签名"  v-model="shu.duanxin.dayu.denglu.qianming"  size="small" style="width:40%">
						<template slot="prepend">登录签名</template>
					</el-input>
					<el-input placeholder="模板ID如 ：SMS_16361531" v-model="shu.duanxin.dayu.denglu.id" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" >模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
					
					<el-input placeholder="注册签名" v-model="shu.duanxin.dayu.zhuce.qianming" size="small" style="width:40%">
						<template slot="prepend">注册签名</template>
					</el-input>
					<el-input placeholder="模板ID如 ：SMS_16361531"  v-model="shu.duanxin.dayu.zhuce.id" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" >模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
					
					<el-input placeholder="修改密码" v-model="shu.duanxin.dayu.biangeng.qianming" size="small" style="width:40%">
						<template slot="prepend">修改签名</template>
					</el-input>
					<el-input placeholder="模板ID如 ：SMS_16361531" v-model="shu.duanxin.dayu.biangeng.id" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" >模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
				
					<el-input placeholder="身份验证" v-model="shu.duanxin.dayu.shenfen.qianming" size="small" style="width:40%">
						<template slot="prepend">身份签名</template>
					</el-input>
					<el-input placeholder="模板ID如 ：SMS_16361531" v-model="shu.duanxin.dayu.shenfen.id" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" >模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
				
					<el-input placeholder="活动验证" v-model="shu.duanxin.dayu.huodong.qianming" size="small" style="width:40%">
						<template slot="prepend">活动签名</template>
					</el-input>
					<el-input placeholder="模板ID如 ：SMS_16361531" v-model="shu.duanxin.dayu.huodong.id" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" >模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
					
				</el-form-item>
				<el-form-item label-width="200px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item>
		<div><span class="biaoti">支付参数</span></div>
		<el-collapse-item title="货到付款">
			<el-form label-width="80px" :model="shu.zhifu.huodao" style="margin-top: 20px">
				<el-form-item  label="货到付款" label-width="180px">
					<el-radio-group  v-model="shu.zhifu.huodao.kaiguan">
						<el-radio label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio label="0">关闭</el-radio>	
					</el-radio-group>
				</el-form-item>
				<el-form-item label-width="180px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item>
		<el-collapse-item title="余额支付">
			<el-form label-width="80px" :model="shu.zhifu.yu_e" style="margin-top: 20px">			
				<el-form-item  label="余额付款" label-width="180px">
					<el-radio-group  v-model="shu.zhifu.yu_e.kaiguan">
						<el-radio label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio label="0">关闭</el-radio>	
					</el-radio-group>
				</el-form-item>
				<el-form-item label-width="180px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item>
		<!-- 支付宝支付 -->
		<el-collapse-item title="支付宝支付">
			<el-form label-width="80px" :model="shu.zhifu.alipay"  style="margin-top: 20px">
				<el-form-item label="支付宝支付" label-width="200px">
					<el-tag type="success">您的支付宝账号必须支持手机网页即时到账接口, 才能使用手机支付功能,
						<el-link :underline="false" type="info" closable>申请及详情请查看这里</el-link>
					</el-tag>
				</el-form-item>
				<el-form-item label="是否开启" label-width="180px">
					<el-radio-group  v-model="shu.zhifu.alipay.kaiguan">
						<el-radio label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio label="0">关闭</el-radio>	
					</el-radio-group>
				</el-form-item>
				<el-form-item label="AppId" label-width="200px">
					<el-input v-model="shu.zhifu.alipay.app_id" placeholder="请输入AppId"></el-input>
				</el-form-item>
				<el-form-item label="支付宝公钥" label-width="200px">
					<el-input v-model="shu.zhifu.alipay.alipay_public_key" placeholder="请输入支付宝公钥"></el-input>
					<el-form-item class="tishi" style="color: #737373;">支付宝提供公钥</el-form-item>
				</el-form-item>
				<el-form-item label="(RSA2)私密钥" label-width="200px">
					<el-input type="textarea"  placeholder="请输入(RSA2)私密钥" v-model="shu.zhifu.alipay.apprsa"></el-input>				
				</el-form-item>
				<el-form-item label-width="180px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item>
		<!-- 微信支付 -->
		<el-collapse-item title="微信支付(公众号)" >
			<el-form label-width="80px" :model="shu.zhifu.weixin"  style="margin-top: 20px">			
				<el-form-item label="是否开启" label-width="180px">
					<el-radio-group  v-model="shu.zhifu.weixin.kaiguan"  v-if="shu.zhifu.weixin">
						<el-radio label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio label="0">关闭</el-radio>	
					</el-radio-group>
				</el-form-item>			
				<el-form-item label="身份标识(appId)" label-width="200px">
					<el-input v-model="shu.zhifu.weixin.appid" placeholder="请输入AppId"></el-input>				
				</el-form-item>
				<el-form-item label="身份密钥(appSecret)" label-width="200px">
					<el-input v-model="shu.zhifu.weixin.appsecret" placeholder="请输入appSecret"></el-input>				
				</el-form-item>
				<el-form-item label="微信支付商户号(MchId)" label-width="200px">
					<el-input v-model="shu.zhifu.weixin.mchid" placeholder="请输入MchId"></el-input>					
				</el-form-item>
				<el-form-item label="商户支付密钥(API密钥)" label-width="200px">
					<el-input v-model="shu.zhifu.weixin.apikey" placeholder="点击生成密钥">
						<el-button slot="append" @click="Suijizifu(shu.zhifu.weixin)">生成密钥</el-button>
					</el-input>					
				</el-form-item>
				<el-form-item label="apiclient_cert证书文件" label-width="200px">
					<!-- <el-input type="textarea"  placeholder="请输入apiclient_cert证书" v-model="shu.zhifu.weixin.cert"></el-input>	 -->
					<Shangwenjian v-model="shu.zhifu.weixin.cert"></Shangwenjian>
				</el-form-item>
				</el-form-item>
				<el-form-item label="apiclient_key密钥文件" label-width="200px">
					<!-- <el-input type="textarea"  placeholder="请输入apiclient_cert证书" v-model="shu.zhifu.weixin.key"></el-input> -->
					<Shangwenjian v-model="shu.zhifu.weixin.key"></Shangwenjian>					
				</el-form-item>					
				<el-form-item label-width="180px">
         	        <Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item>
		<!-- APP微信支付开关 -->
		<el-collapse-item title="微信支付(APP)">
			<el-form label-width="80px" :model="shu.zhifu.weixinapp" style="margin-top: 20px">
				<el-form-item label="是否开启" label-width="180px">
					<el-radio-group  v-model="shu.zhifu.weixinapp.kaiguan">
						<el-radio label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio label="0">关闭</el-radio>	
					</el-radio-group>
				</el-form-item>			
				<el-form-item label="身份标识(appId)" label-width="200px">
					<el-input v-model="shu.zhifu.weixinapp.appid" placeholder="请输入AppId"></el-input>				
				</el-form-item>
				<el-form-item label="身份密钥(appSecret)" label-width="200px">
					<el-input v-model="shu.zhifu.weixinapp.appsecret" placeholder="请输入appSecret"></el-input>
				
				</el-form-item>
				<el-form-item label="微信支付商户号(MchId)" label-width="200px">
					<el-input v-model="shu.zhifu.weixinapp.mchid" placeholder="请输入MchId"></el-input>					
				</el-form-item>
				<el-form-item label="商户支付密钥(API密钥)" label-width="200px">
					<el-input v-model="shu.zhifu.weixinapp.apikey" placeholder="点击生成密钥">
						<el-button slot="append" @click="Suijizifu(shu.zhifu.weixinapp)">生成密钥</el-button>
					</el-input>					
				</el-form-item>
				<el-form-item label="apiclient_cert证书文件" label-width="200px">
					<Shangwenjian v-model="shu.zhifu.weixinapp.cert"></Shangwenjian>
				</el-form-item>
				</el-form-item>
				<el-form-item label="apiclient_key密钥文件" label-width="200px">
					<Shangwenjian v-model="shu.zhifu.weixinapp.key"></Shangwenjian>					
				</el-form-item>					
				<el-form-item label-width="200px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item>
		<!-- 小程序微信支付开关 -->
		<el-collapse-item title="微信支付(小程序)">
			<el-form label-width="80px" :model="shu.zhifu.xiaochengxu" style="margin-top: 20px">
				<el-form-item label="是否开启" label-width="180px">
					<el-radio-group  v-model="shu.zhifu.xiaochengxu.kaiguan">
						<el-radio label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio label="0">关闭</el-radio>	
					</el-radio-group>
				</el-form-item>			
				<el-form-item label="身份标识(appId)" label-width="200px">
					<el-input v-model="shu.zhifu.xiaochengxu.appid" placeholder="请输入AppId"></el-input>				
				</el-form-item>
				<el-form-item label="身份密钥(appSecret)" label-width="200px">
					<el-input v-model="shu.zhifu.xiaochengxu.appsecret" placeholder="请输入appSecret"></el-input>
				
				</el-form-item>
				<el-form-item label="微信支付商户号(MchId)" label-width="200px">
					<el-input v-model="shu.zhifu.xiaochengxu.mchid" placeholder="请输入MchId"></el-input>					
				</el-form-item>
				<el-form-item label="商户支付密钥(API密钥)" label-width="200px">
					<el-input v-model="shu.zhifu.xiaochengxu.apikey" placeholder="点击生成32位密钥">
						<el-button slot="append" @click="Suijizifu(shu.zhifu.xiaochengxu)">生成密钥</el-button>
					</el-input>					
				</el-form-item>
				<el-form-item label="apiclient_cert证书文件" label-width="200px">
					<!-- <Shangwenjian v-model="shu.zhifu.xiaochengxu.cert"></Shangwenjian>	-->
					<el-input type="textarea"  placeholder="请输入apiclient_cert证书" v-model="shu.zhifu.xiaochengxu.cert"></el-input>
				</el-form-item>
				</el-form-item>
				<el-form-item label="apiclient_key密钥文件" label-width="200px">
					<!-- <Shangwenjian v-model="shu.zhifu.xiaochengxu.key"></Shangwenjian>					 -->
					<el-input type="textarea"  placeholder="请输入apiclient_cert证书" v-model="shu.zhifu.xiaochengxu.key"></el-input>
				</el-form-item>					
				<el-form-item label-width="200px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item> 	
		<div><span class="biaoti">其他接口</span></div>
		<el-collapse-item title="APP更新(FIR.IM)"  >
				<el-form label-width="80px" :model="shu.qita.fir" style="margin-top: 20px;">					
					<el-form-item label="Token" label-width="180px">
						<el-input v-model="shu.qita.fir.token"></el-input>
					</el-form-item>
					<el-form-item label="安卓ID" label-width="180px">
						<el-input v-model="shu.qita.fir.anzhuo"></el-input>
					</el-form-item>
					<el-form-item label="苹果ID" label-width="180px">
						<el-input v-model="shu.qita.fir.pingguo"></el-input>
					</el-form-item>
					<el-form-item label-width="180px">
						<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
					</el-form-item>
				</el-form>
		</el-collapse-item>
		<el-collapse-item title="腾讯地图" name="4">
			<el-form label-width="80px" :model="shu.qita.tengxun" style="margin-top: 20px;">
				<el-form-item label="Key" label-width="180px" style="margin-left:20px ;">
					<el-input v-model="shu.qita.tengxun.key"></el-input>				
				</el-form-item>
				<el-form-item label-width="200px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-collapse-item>
		<el-collapse-item title="七牛云" >
			<el-form label-width="80px" :model="shu.qita.qiniuyun"  style="margin-top: 20px;">
				<el-form-item label="是否开启" label-width="180px">
					<el-radio-group  v-model="shu.qita.qiniuyun.kaiguan">
						<el-radio label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio label="0">关闭</el-radio>	
					</el-radio-group>
				</el-form-item>	
				<el-form-item label="访问域名" label-width="180px" >
					<el-input v-model="shu.qita.qiniuyun.yuming"></el-input>				
				</el-form-item>
				<el-form-item label="空间名称" label-width="180px" >
					<el-input v-model="shu.qita.qiniuyun.kongjianming"></el-input>
				</el-form-item>
				<el-form-item label="AccessKey" label-width="180px" >
					<el-input v-model="shu.qita.qiniuyun.accesskey"></el-input>
				</el-form-item>
				<el-form-item label="SecretKey" label-width="180px" >
					<el-input v-model="shu.qita.qiniuyun.secretkey"></el-input>					
				</el-form-item>
				<el-form-item label-width="180px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>						
				</el-form-item>
			</el-form>			
		</el-collapse-item>
		<el-collapse-item title="飞鹅云打印" v-if="shu.qita.feie">
			<el-form label-width="80px" :model="shu.qita.feie"   style="margin-top: 20px;">
				<el-form-item label="是否开启自动" label-width="180px">
					<el-radio-group  v-model="shu.qita.feie.kaiguan">
						<el-radio label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio label="0">关闭</el-radio>	
					</el-radio-group>
				</el-form-item>	
				<el-form-item label="USER" label-width="180px" >
					<el-input v-model="shu.qita.feie.user"></el-input>				
				</el-form-item>
				<el-form-item label="UKEY" label-width="180px" >
					<el-input v-model="shu.qita.feie.ukey"></el-input>
				</el-form-item>
				<el-form-item label="编辑号(SN)" label-width="180px" >
					<el-input v-model="shu.qita.feie.sn"></el-input>
				</el-form-item>	
				<el-form-item label-width="180px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>						
				</el-form-item>
			</el-form>			
		</el-collapse-item>
	</el-collapse>
	</div>
	
</template>

<script>
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	import Bianjiqi from '../../zujian/Bianjiqi.vue'	
	let that;
	export default {
		data() {
			return {				
				shu:{
					jichupeizhi:{cengji:0,huiyuantequan:"",banbenhao:''},
					tixian:{shouxufei:0,zidongtixian:0},
					duanxin:{
						dayu:{
							denglu:{qianming:'',id:''},
							zhuce:{qianming:'',id:''},
							huodong:{qianming:'',id:''},
							biangeng:{qianming:'',id:''}, 
							shenfen:{qianming:'',id:''}
						},
					},
					zhifu:{
						huodao:{kaiguan:0},
						yu_e:{kaiguan:0},
						alipay:{kaiguan:0},
						weixin:{kaiguan:0},
						weixinapp:{kaiguan:0},
						xiaochengxu:{kaiguan:0},
					},
					qita:{
						fir:{token:'',anzhuo:'',pingguo:''},
						tengxun:{key:''},
						qiniuyun:{kaiguan:0},
						feie:{kaiguan:0}
					}
				},	
				
			};
		},
		components: {
			Shangwenjian,
			Bianjiqi,			
		},
		created() {
			that = this;
			that.CSH();
			
		},
		methods: {
			CSH() {			
				this.$post('k=peizhi',function(s) {
					if(!s.shu.qita.feie){
						s.shu.qita.feie={kaiguan:0};					
					}
					if(!s.shu.qita.fir){
						s.shu.qita.fir={kaiguan:0};					
					}
					if(!s.shu.qita.qiniuyun){
						s.shu.qita.qiniuyun={kaiguan:0};					
					}
					if(!s.shu.qita.tengxun){
						s.shu.qita.tengxun={kaiguan:0};					
					}
					that.shu=s.shu;								
				});
			},
			Tijiao(){
				this.$post('k=peizhi&c=xiugai',that.shu,function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi==1){
						that.CSH();
					}		
				});
			},
			Suijizifu(e){				
				e.apikey=this.$suijizifu();
			},
			set(a,b){
				// this.$set(this.shu.qita,b,{kaiguan:0})
			}
		},
	}
</script>

<style>
	.el-collapse-item .el-form{
		width:60%;
	}
	.el-collapse-item__header {
		text-indent: 30px;
	}
		
	.el-collapse-item__header{
		background:#f7fafa ;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
	}
	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-top: 20px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}
	.tishi{
		color: #909399;
	}
</style>
